import {observer} from 'mobx-react';
import {UploadFiles} from 'shared/components';
import {Modal, ModalButtons} from 'shared/components/modals';
import {FormattedMessage} from 'react-intl';

const PayrollFileUploadModal = observer(({uiState}) => {
  const {payrollUpload, isUploading, uploadFileModalOpen, errors} = uiState;

  return (
    <Modal isOpen={uploadFileModalOpen} onHide={() => uiState.closeUploadFileModal()} size='md'>
      <div className='h2 pt1 medium'>
         <FormattedMessage id='payroll.uploader.Upload File'/>
      </div>
      <div className='mt3 mb2'>
        <FormattedMessage id="payroll.uploader.Upload employee's hours worked or one off bonuses." />
      </div>
      <UploadFiles
        maxFiles={1}
        onUploadStarted={() => uiState.onUploadStarted()}
        onUploadFinished={() => uiState.onUploadFinished()}
        errorMessage={errors.payrollFile}
        isUploading={isUploading}
        onChange={files => payrollUpload.payrollFiles = files}
        modelType='payroll/payroll_upload'
      />
      <ModalButtons
        saveCaption='payroll.uploader.Upload'
        onSave={() => uiState.createPayrollUpload()}
        onCancel={() => uiState.closeUploadFileModal()}
        enabled={!isUploading}
      />
    </Modal>
  );
});

export default PayrollFileUploadModal;
